var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sx",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h450v450H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(1.1378)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed2939",
    fillRule: "evenodd",
    d: "M0 0h675v225H300L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002395",
    fillRule: "evenodd",
    d: "M0 450h675V225H300L0 450z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m0 0 300 225L0 450V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m151.4 169.8.1-3.4s-1.9-3 .3-6.2c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.2 0 0-4.5.8-6.4-3 0 0-4.4.9-5.7-2.2 0 0-4.2 1.5-6.8-2.1 0 0-4.5 1.8-6.4-1.6-1.8 3.4-6.3 1.6-6.3 1.6-2.5 3.6-6.8 2-6.8 2-1.2 3.2-5.6 2.3-5.6 2.3-2 3.7-6.5 3-6.5 3-.4 3.8-5 4.1-5 4.1a5.3 5.3 0 0 1-3.7 5.7c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2l74.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M377.2 843.1v-3.5s-1.8-3 .4-6c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.1 0 0-4.4.7-6.3-3 0 0-4.4.8-5.6-2.2 0 0-4.3 1.5-6.8-2.1 0 0-4.5 1.8-6.3-1.6-1.9 3.4-6.4 1.6-6.4 1.6-2.4 3.5-6.7 2-6.7 2-1.2 3.1-5.5 2.3-5.5 2.3-2 3.7-6.5 3-6.5 3-.4 3.7-4.9 4-4.9 4a5.1 5.1 0 0 1-3.7 5.6c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2l73.9.3z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M149.7 165.5c-11.7-1.2-25.2-4-35.6 1.9-7-4.1-16.7-3.9-25-3-4.4.7-9.7.7-14.4 1.5l-.7.1c-8.6.6-16.3-2-23.7-5.2 2.4 13.3 5 27 6.3 41 2.8 20.6-9.8 38-4.7 58.4 3.1 9.8 13.9 15.5 23.8 16.6a188.7 188.7 0 0 1 28.2 4 28 28 0 0 1 4.9 1.7 17.3 17.3 0 0 1 5.7 4c5.4-5.5 13.2-7 21-7.8 13.8-1.7 31-.8 39.5-13.4v-.7c4.6-7 4-17.6 2-25.5-.2-2.7-.9-5.1-1.3-7.8-8.5-22.4-1.2-47.6 2.4-70.2-4.4 2.4-9.4 3.6-14.4 4.8-4 .5-8.3.3-12.4 0l-1.6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cfe1",
    d: "M167.2 229.9c-.1 1.5.7 2.6 1 4 1.6 9.8 3.2 22.8-7 28.9-11 7-25.7 4-38.6 7.8-2.6.7-6.2 3-8 4.7-1.2-.7-2.3-1.9-3.8-2.6-10.7-5.6-24.5-3.8-36.5-6.8-6-2-12.3-6.6-13.9-12.8-3.9-16.2 5.5-30 4.4-46a195.7 195.7 0 0 0-5.6-35.6 50 50 0 0 0 30.8 3c7.8-1 17-1 24.2 2.2a49 49 0 0 1 13.1-3c8.3.8 17.2 2.3 25.7 2.3a44 44 0 0 0 15.8-4.2c-3 19-8.6 39-1.7 58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m150.3 233.7-.1-17.9h2.2L125 198.1V189h2.6l-13.7-9.8-13.6 9.8h2.6v9.1l-27 17.7h2l.2 17.8h72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M376 906.5v-17.8h2.1l-27-17.5-.1-9h2.6l-13.6-9.8-13.5 9.7h2.6l.1 9.1-27 17.5h2.2v17.7H376z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M158.7 257.1v5.6h-88V257h88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M384.4 929.8v5.5H297v-5.6h87.4z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.5 256.8v-19H80l-.2 19.2.2-19-5-.1v-4h78.6v4h-4.9l.1 19.2-.1-19.2h3.6v19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M302.8 929.4v-18.8h3.5l-.2 19 .2-18.8-5-.2v-4l78 .1v4h-4.8l.1 19-.2-19h3.6l.1 18.8",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M319.6 924.8v-13.1H309v13l10.5.1",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M312 914.4v7.6h4.8v-7.6h-4.9m59 10.4-.1-13h-10.4v13h10.5",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M363.2 914.5v7.6h4.8v-7.6h-4.8m7.6-11v-13h-10.5v13h10.5z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M363.1 893.2v7.6h4.8v-7.6h-4.8m-43.6 10.3v-13.1H309v13h10.5z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M311.9 893.1v7.6h4.8v-7.6h-4.8m26.6 10.4v-13.1H328v13h10.5",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M330.8 893.1v7.6h4.8v-7.6h-4.8m22.3 10.4v-13l-10.5-.1v13l10.5.1",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M345.4 893.1v7.6h4.9v-7.6h-4.9",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m129.8 226.7.1 30.4H99.4l-.1-30.5h30.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m355.7 899.5.1 30.2h-30.3l-.1-30.2h30.3zm-30.5 8.6h30.6M329 929.7v-21.4m23.1 21.4v-21.3m14.7-21.8-17-12.4h-19.3l-17 12.4h53.3M332 863.8v7.6h16.2v-7.6H332",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M336.4 865.7v3.8h7.4v-3.8h-7.4M340 855l9 6.4h-17.9l9-6.4",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M150.6 177.6c2.6 0 3.2 10.6 3.2 15.9a24 24 0 0 1 9.3 6.5h-24.8a24 24 0 0 1 9.1-6.5c0-5.3.6-16 3.2-15.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M376.3 850.8c2.6 0 3.2 10.5 3.2 15.8 2.2.6 7.1 3.7 9.2 6.4h-24.6c2.1-2.7 7-5.8 9.1-6.4 0-5.3.6-15.8 3.1-15.8m-49.5 49.5h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m4.5 0h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m5 0h2.1l-.6 1.2s1 1.4 0 3l.6 1h-2.1l.5-1s-1-1.8 0-3l-.6-1.2zm5.5 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2.1l.6-1s-1-1.8 0-3l-.6-1.1zm4.9 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1m4.9 0h2.2l-.7 1.2s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M114.7 296a82 82 0 0 0 32-5.6l14.6-1.3.2 17.6c-12.2 6.8-40.5 8.3-46.8 8.2-6.2 0-34.9-1.4-47.2-8.2l.2-17.7 14.5 1.3a86.9 86.9 0 0 0 32.5 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M340.7 968.4c11.4 0 25.3-2.3 31.9-5.7l14.3-1.2.3 17.5c-12.1 6.7-40.3 8.2-46.4 8.1-6.2 0-34.7-1.4-47-8.2l.2-17.5 14.4 1.3c6.6 3.4 21 5.7 32.3 5.7",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m30.2 220.7 12.8 4-3.9 20.7-12 1.9s-2-10.9 3.1-26.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m256.9 893.6 12.6 4-3.8 20.5-12 1.9s-2-10.8 3.2-26.4z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7e7e",
    d: "m39.1 245.2-12 2.1 7.6-10.9 4.4 8.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m265.7 917.9-12 2 7.6-10.7 4.4 8.7",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m22.6 235.6 12.3.9c.3 10.4 1.5 50.1 49 52.3l-1.5 14.5c-57.8.6-62.1-48.8-59.8-67.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m249.3 908.4 12.2.8c.3 10.4 1.5 49.8 48.7 52l-1.5 14.4c-57.4.6-61.7-48.4-59.4-67.2zm44.8 70.1 14.4-3.1",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m198.1 220.8-12.7 4 4 20.7 12.1 2s2-11-3.4-26.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m423.5 893.7-12.6 4 4 20.5 12 2s2-10.8-3.4-26.5z",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e7e7e",
    d: "m189.4 245.3 12.1 2.1-7.7-10.8-4.4 8.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m414.9 918 12 2.1-7.7-10.7-4.3 8.6",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "m205.9 235.7-12.3.9c-.2 10.4-1.1 50.2-48.6 52.3l1.6 14.4c57.8.7 61.8-48.7 59.3-67.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m431.2 908.5-12.2.8c-.2 10.4-1 49.9-48.2 52l1.6 14.3c57.4.7 61.3-48.3 58.8-67zm-44.2 70-14.4-3",
    transform: "matrix(1.0075 0 0 1.0074 -228.6 -679.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009fc5",
    d: "M107 304.8c-.3.2-.8.2-1.3.2l-2.3-.1.2-2.9 2.3.1c.4 0 .8.2 1 .3.5.2.7.7.6 1.3 0 .5-.2.9-.5 1m-3.9 4.6.3-3.5 2.6.2a3 3 0 0 0 2-.6c.4-.5.7-1 .7-1.7a2.2 2.2 0 0 0-.6-1.8 2.8 2.8 0 0 0-1.8-.7l-3.8-.2-.5 8.2h1.1m8.4-6.8h2.8l1 .2c.3.2.5.6.5 1.2s-.1 1-.4 1.2c-.3.2-.8.3-1.3.3h-2.7v-2.9m0 7.3v-3.5h2.6c.5 0 .9 0 1.1.2.4.1.6.5.6 1v1.4l.1.7.1.3h1.4v-.2a.7.7 0 0 1-.4-.5v-1.8c0-.5-.2-.9-.4-1a1.5 1.5 0 0 0-.7-.6l1-.7.2-1.3c0-.9-.4-1.6-1.2-1.9a4.1 4.1 0 0 0-1.6-.3h-3.9v8.2h1.1m8.8-1.7a4 4 0 0 1-.9-2.3c0-1.2.2-2 .7-2.6.5-.7 1.2-1 2.1-1 1 0 1.6.2 2.2.8.5.5.9 1.3 1 2.3 0 .9-.2 1.7-.6 2.4-.5.7-1.1 1.1-2.2 1.2-1 0-1.8-.2-2.3-.8m-1.4-5.2a4.7 4.7 0 0 0-.7 2.9 4.7 4.7 0 0 0 1.2 3 4 4 0 0 0 3.1 1 3.9 3.9 0 0 0 3.2-1.5 5 5 0 0 0 .8-3.1 4.4 4.4 0 0 0-1-2.8c-.8-.9-2-1.3-3.4-1.2-1.5 0-2.5.6-3.2 1.7m38.7-11.9a4.2 4.2 0 0 1 2.1.1c1 .3 1.6 1 2 2l-1.2.2a2 2 0 0 0-1-1.2 3.1 3.1 0 0 0-1.7-.1 2.6 2.6 0 0 0-1.9 1.1c-.4.7-.5 1.5-.3 2.7.1 1 .5 1.7 1 2.2.6.6 1.3.8 2.3.6a2.8 2.8 0 0 0 1.8-1c.4-.4.6-1.2.4-2.1l-2.6.4-.2-.9 3.7-.6.7 4.4h-.7l-.4-1a4 4 0 0 1-1 1 3.8 3.8 0 0 1-1.8.8 3.8 3.8 0 0 1-2.7-.6 4.5 4.5 0 0 1-1.7-3 4.5 4.5 0 0 1 .6-3.4 3.6 3.6 0 0 1 2.6-1.6m8.4-.6 2.6-1a2 2 0 0 1 1-.1c.4 0 .8.3 1 .9.2.5.2.9 0 1.2l-1.1.7-2.5 1-1-2.7m2.6 6.8-1.3-3.3 2.5-.9a3 3 0 0 1 1-.2c.4 0 .7.3 1 .8l.5 1.3.3.6.2.2 1.3-.5v-.1c-.2 0-.4-.2-.6-.4l-.3-.6-.4-1c-.2-.5-.4-.8-.7-1a2.1 2.1 0 0 0-.9-.2c.3-.3.5-.6.6-1a2.2 2.2 0 0 0-.1-1.2c-.4-.9-1-1.4-1.9-1.4-.4 0-1 0-1.6.2l-3.7 1.4 3 7.7 1.1-.4m9.6-4-4.7-7 5.2-3.3.6.9-4.3 2.7 1.5 2 3.9-2.4.5.8-3.9 2.5 1.6 2.3 4.3-2.8.6.8-5.3 3.4m4.2-12.1 1.3-1.5c.6-.7 1.3-1 2-.9a4 4 0 0 1 2.3 1.1 4 4 0 0 1 1.2 1.9c.2.5.1 1 0 1.4l-.6.7-1.4 1.5-4.8-4.2m7 3.2c1-1 1.3-2.2.7-3.5a5.9 5.9 0 0 0-1.5-2 4.6 4.6 0 0 0-2.7-1.2 3.2 3.2 0 0 0-2.8 1.2l-2.3 2.4 6.4 5.6 2.3-2.5m4.9-6.4-7.3-4.3.6-1 7.3 4.3-.6 1m2.9-5-8-3.1 2.4-5.6 1 .4-2 4.6 2.4.9 1.8-4.2 1 .4-1.8 4.2 2.6 1 2-4.6 1 .4-2.4 5.6m3.6-9.7-8.3-1.8.3-1.3 7.6-2.6-6.7-1.4.2-1 8.3 1.7-.2 1.3-7.7 2.6 6.7 1.5-.2 1m-.7-10.5.1-1c.5 0 1 0 1.2-.3.6-.3 1-.9 1-1.8v-1.2c-.2-.7-.6-1-1.2-1.1-.5 0-.8 0-1 .3-.2.3-.5.7-.6 1.3l-.4 1-.7 1.6c-.4.5-1 .7-1.7.6a2.5 2.5 0 0 1-1.8-1c-.5-.5-.6-1.2-.5-2.2 0-.8.3-1.5.8-2.1.5-.5 1.2-.8 2.1-.7v1c-.5 0-.9.1-1.1.3-.5.3-.8.8-.8 1.7-.1.6 0 1 .2 1.4.3.3.6.5 1 .5s.7 0 1-.4l.6-1.4.3-1.1c.2-.6.4-1 .7-1.3a2.2 2.2 0 0 1 1.8-.6c1 .1 1.6.5 2 1.2.3.7.4 1.5.3 2.4a3 3 0 0 1-1 2.3 3 3 0 0 1-2.3.6M28.2 252l.2 1c-.4.1-.8.3-1 .6-.6.4-.7 1-.6 2l.4 1.1c.4.6.9.9 1.5.8.4-.1.7-.3.9-.6l.2-1.4v-1.2l.4-1.6c.2-.5.7-.9 1.4-1a2.5 2.5 0 0 1 2 .5c.6.4 1 1 1 2a3 3 0 0 1-.2 2.3c-.3.6-.9 1-1.8 1.2l-.2-1c.4-.2.7-.3 1-.6.3-.4.4-1 .3-1.8-.1-.6-.3-1-.7-1.3a1.3 1.3 0 0 0-1-.3 1 1 0 0 0-.8.7 4 4 0 0 0-.2 1.5v1.2a3 3 0 0 1-.4 1.4 2 2 0 0 1-1.5 1c-1 .2-1.7 0-2.2-.6a4.3 4.3 0 0 1-1-2.2 3.4 3.4 0 0 1 .3-2.5 2.7 2.7 0 0 1 2-1.2m-.5 10.9 8.1-2.5 2 5.7-1 .4-1.6-4.7-2.5.7 1.4 4.3-1 .3-1.3-4.3-2.8.8 1.6 4.8-1 .3-1.9-5.8m3.6 9.9 7.5-4 .8 1.4-5.2 5.4 7.5-1.2.8 1.3-7.5 4-.5-1 4.4-2.3.8-.4 1.1-.6-7.5 1.3-.5-1 5.1-5.4-.3.2-.8.4a6.1 6.1 0 0 1-.8.5l-4.4 2.3-.5-1m13.9 11c-.4 0-.7-.2-1.1-.6l-1.6-1.6 2.1-2 1.6 1.6.6.9c.2.5 0 1-.4 1.3-.4.4-.8.6-1.2.5m-6 .7 2.6-2.4 1.8 2a3 3 0 0 0 1.9.8 2.6 2.6 0 0 0 1.7-.8c.5-.5.8-1 .8-1.7 0-.6-.3-1.1-.8-1.7l-2.6-2.7-6.2 5.7.8.8m7.5 6.6 4.4-7 5.3 3.2-.5.9-4.4-2.6-1.3 2.1 4 2.4-.6.8-4-2.4-1.5 2.4 4.4 2.6-.5.9-5.4-3.3m13.3-1.3 2.7.8.8.5c.3.3.4.8.2 1.3-.1.5-.4.8-.8 1l-1.3-.1-2.5-.8.9-2.7m-2.3 6.9 1-3.4 2.6.8 1 .5c.2.3.3.7.1 1.2L62 297l-.2.7v.2l1.4.5v-.2l-.2-.6c0-.1 0-.4.2-.7l.3-1c.1-.5.2-.8 0-1a1.7 1.7 0 0 0-.5-.8c.4-.1.8-.2 1.1-.5.3-.2.5-.6.7-1 .3-1 .1-1.7-.5-2.3-.4-.2-.8-.5-1.5-.7l-3.7-1.2-2.6 7.8 1 .4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc715f",
    d: "M69 154.4c1-2.4 9.9-8.7 39.4-6 0 0 5 3.1 7.9 2.7 1.6-.2-1 .1-3.2-1.7s-2.7-5.5 2.4-5.4c5 .1 24 1.2 24.3 2.9.3 1.7-10 2.4-13.8 2.3-3.9 0-3.4 1.9.4 1.7 12-.4 25-4.6 39 5.2 1.6 1.1-4.3 1.3-8.8-.6 0 0-12.2.7-17.4-.2 0 0-4 3.3-9.4 3 .7 1.7-2 8-18.5 3.3-2.8.8-12.7 2.5-11.7-.5-2.6 0-7.2.8-7.9-.7-.6-1.4 8.1-3.7 9.7-5.3 0 0-18.6.2-22.1-1 0 0-11 2.4-10.3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008737",
    d: "M75 180.4c.3-.5.5-1.5 1.3-1.5 1.9.5 3.1 3.9 5.4 1.7.8-.2 1 .9 1.7 1 .5 1.9 2-.3 3-.2a14.2 14.2 0 0 1 8.3-.8c0 1.8-1.4 3.8-3.2 4.9 0 1.8 1.7 3 1.7 4.9-.3.7 0 1.8-1 2-1.4-.3-2.7-.4-3.8-1.1-.2-.2-.3-.4-.5-.4-.2.7.8 1.3 1.2 2-.7 1-1.8 0-2.7 0-.3.7 0 1.5-.7 2-1.2-.1-1.5-1.4-2.2-2-.7.8.6 1.3.7 1.9-.4 2.4-.4 4.8-2.8 6.4l-1.6.8c-.4-1.3-.2-3.1-.5-4.4-1 1.6-1.7 3-3 4.3-1.7-.6-2.7-2.5-3-4.1a5.1 5.1 0 0 1 1.2-5.5c-.5-1-2.3-.7-2.5-2.1-2.6-1.7-4 3-5.7.5A7.6 7.6 0 0 1 68 184c-.3-1-1.5-.7-2.2-1.2-1.7-1.4-4-2.8-3.9-5.3a12.3 12.3 0 0 1 13 2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M77.2 180.2c0 2 1.4.5 2.5 1.7-.9-.3-1.5 1.5-2.3.5l-.6.5c.3.7 1 .8.3 1.5-.9.4-1-.8-1.5-1.2 0-.2.1-.6-.2-.7-.5.4-1 .6-1.8.5-.2-.4-.6-1-.2-1.2.7-1 1.8.3 2.3-.3.1-.6-.4-1.3.3-1.8.4.1 1-.1 1.2.4m5.5 1.7c0 .4-.2 1 .3 1.2.7-.3 1.4 0 1.8.6 0 .4.1.8-.4 1l-1-.2c0-.2-.3-.3-.4-.5-.5-.2-.7.2-1 .4.2.4.8.7.6 1.2-.6.6-.9-.6-1.6-.3-.4-.2.2-1.1-.5-1.4-.9 0-.3 1.4-1.4.9-.4-.5-.8-1-.3-1.6a1.4 1.4 0 0 1 1.6.2c.7-.7.7-3.6 2.3-1.5m-6.8 3c.4.6-.1 1.5.4 2.2 1-1.7 1.8.4 2.9.2.3.4 0 1 .1 1.4-1.3.4-2.9.8-4-.3l-.4.4c.7.6 1.4 1.4.8 2.5-1 .2-2.5.2-3-.8-.2-.9.6-1.5-.3-2.1-.6.8-.6 1.9-2 1.1a1.6 1.6 0 0 1-.7-2.2c1-1.4 2.5 0 3.4-.7.2-1.2-.3-2.2.8-2.9 1-.1 1.4.6 2 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.6 185.5c-.4 2-2-.1-2.7-.2 1-1.7 1.6.6 2.7.2m4.8 2.2c-1 .3-1-1-1.5-1.5l.5-.4 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M83 187.3c.2.7-.8 1.3.1 1.8l.7-.7c.8.2 1.6.4 2.1 1 .6 1.6-1 1.6-1.8 2h-.8c.2-.5-.4-.7-.6-1a.8.8 0 0 0-.9.4c.2 1 1.4 1.7.1 2.5-1 0-2.5.4-2.4-1-.4-.8 1-2-.5-2-.5 1-1 2-2.3 1l.1-1.5c1.2 0 2.7.2 3.3-1.2.3-1-.6-1.9.2-2.7 1.3-.3 2 .6 2.6 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 189.6c.4.8-.5.8-1 1.2-.5 0-.8-.2-1.2-.6-.2-.9.5-1 1-1.3.6-.3.8.4 1.2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81.3 190c-.1.3-.3.2-.5.3l-.2-1c.4 0 .9.2.7.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSx);
export default __webpack_public_path__ + "static/media/sx.1cda7a4ed0629d49068ebca6744f3646.svg";
export { ForwardRef as ReactComponent };